import { useTheme } from "next-themes";
import { Sun, Moon } from "lucide-react";
import { useLiquidGlass } from "@/contexts/LiquidGlassContext";
import { cn } from "@/lib/utils";

const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();
  const { liquidGlassEnabled, shimmerDirection } = useLiquidGlass();

  return (
    <div className={cn(
      "flex items-center rounded-full p-0.5 gap-0.5 transition-all duration-500",
      liquidGlassEnabled ? `liquid-glass-outline shimmer-${shimmerDirection}` : "bg-secondary"
    )}>
      <button
        onClick={() => setTheme("light")}
        className={`flex items-center justify-center p-1.5 md:px-3 md:py-1 rounded-full text-[10px] tracking-widest uppercase font-medium transition-all ${
          theme === "light"
            ? "bg-primary text-primary-foreground"
            : "text-muted-foreground hover:text-foreground"
        }`}
        aria-label="Light mode"
      >
        <Sun size={12} />
        <span className="hidden md:inline ml-1">Light</span>
      </button>
      <button
        onClick={() => setTheme("dark")}
        className={`flex items-center justify-center p-1.5 md:px-3 md:py-1 rounded-full text-[10px] tracking-widest uppercase font-medium transition-all ${
          theme === "dark"
            ? "bg-primary text-primary-foreground"
            : "text-muted-foreground hover:text-foreground"
        }`}
        aria-label="Dark mode"
      >
        <Moon size={12} />
        <span className="hidden md:inline ml-1">Dark</span>
      </button>
    </div>
  );
};

export default ThemeToggle;
